import { LegacyWebPersonMetrics } from "../../api/Reports";
import { DonutChart } from "../../shared-components/DonutChart";
import { classNames } from "../../utils";

interface LegacyDonutChartProps {
  metrics: LegacyWebPersonMetrics;
  showLegend?: boolean;
}

export default function LegacyDonutChart({
  metrics,
  showLegend = false,
}: LegacyDonutChartProps) {
  if (!metrics) return null;

  const flagData = [
    {
      label: "Flagged Content",
      value: metrics.totalBadFlagCount,
      color: "#FFA500",
    },
    { label: "Community", value: metrics.totalGoodFlagCount, color: "#3fb274" },
    {
      label: "Keywords",
      value: metrics.keywordNewsFlagCount + metrics.keywordPostFlagCount,
      color: "#126798",
    },
    {
      label: "Relevant Articles",
      value: metrics.relevantNewsFlagCount,
      color: "#808080",
    },
  ];

  const totalFlags = flagData.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="flex px-4 py-2">
      <div
        className={classNames(
          "relative",
          showLegend ? "w-[100px] mt-8" : "w-[60px]"
        )}
      >
        {totalFlags > 0 ? (
          <DonutChart data={flagData} cutout={showLegend ? 40 : 20} />
        ) : (
          <DonutChart
            data={[{ label: "No Data", value: 1, color: "#E5E7EB" }]}
            cutout={showLegend ? 40 : 20}
          />
        )}

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          {showLegend && (
            <h4 className="text-xs text-gray-500 font-light tracking-wide">
              Total Flags
            </h4>
          )}
          <h1 className="text-sm text-gray-800 mt-1 tracking-wide font-light">
            {totalFlags}
          </h1>
        </div>
      </div>

      {showLegend && (
        <div className="relative ml-4 pl-4 border-l border-gray-200 flex items-center">
          <div className="absolute left-0 top-0 w-2.5 h-px bg-gray-200" />
          <div className="absolute left-0 bottom-0 w-2.5 h-px bg-gray-200" />

          <ul className="space-y-2">
            {flagData.map(({ label, value, color }, index) => (
              <li
                key={label}
                className="flex items-center text-gray-600 text-sm leading-[30px]"
              >
                <span
                  className="inline-block w-2 h-2 rounded-full mr-2"
                  style={{ backgroundColor: color }}
                />
                <span className="font-medium mr-2">{value}</span>
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
